import { create } from "zustand";
import { defaultCodes } from "../utils/defaultCodes";

export const useCreateController = create((set) => ({
  data: {
    currentLanguage: "Go",
    funcName: "",
    code: "",
    uri: "/",
    protocol: "http",
    hostname: "",
    file: null,
  },
  setData: (name, value) =>
    set((state) => ({ data: { ...state.data, [name]: value } })),
  clearData: () =>
    set((state) => ({
      data: {
        currentLanguage: "Go",
        funcName: "",
        code: defaultCodes("Go"),
        uri: "/",
        protocol: "http",
        hostname: "",
        file: null,
      },
    })),
}));
